module.exports = __webpack_public_path__ + "img/exit.1f9126d1.png";